export default "__VITE_ASSET__f70ed17e__"